import api from '../api';

export class CommissionDetails {
  static async getCommissionDetails() {
    return api.getApiCall('/api/v1/admins/commissions/commissionGraph-details');
  }

}
